import { storage } from '@/utils/storage';
import { useMyLoading } from '@/store/modules/loading';
import {
  buriedCapital,
  getChannelFlagCode,
  h5Visit,
  pointTrigger,
  getAgreement,
  contractSign,
  operateBuried,
  operateBuriedNoToken,
  getAgreementH5,
  clickCount,
  clickConversionUpClickId,
} from '@/api/login';
import { loginRegister } from '@/hooks/useLoginRegister';
import { buriedPoint } from '@/utils/config';
import { IObjStr, IObjStrObj } from '@/utils/http';
import { baseDayTimeMethod, isPhone, isWeixin } from '@/utils/common';
import useClipboard from 'vue-clipboard3';
const { toClipboard } = useClipboard();
const { VITE_USER_NODE_ENV } = import.meta.env;

/**
 * 初始化登录所需逻辑
 * */
export function pageInitRequest() {
  /**
   * type: 对应的页面，需要的埋点*/
  const initPage = async (type?: string) => {
    const { setRequestLoading } = useMyLoading();
    // 获取动态guide页的方法
    const { getChannelDetailFn } = loginRegister();
    /**获取渠道信息*/
    const channelId = storage.getItem('channelId', 2) || '';
    const token = storage.getItem('token') || '';
    const router = useRouter();
    if (!(channelId || token)) {
      setRequestLoading(true, '未匹配的到渠道信息，请退出重新进入');
      router.replace('/404').then();
      return;
    } else {
      setRequestLoading(false);
    }
    const chanelInfoObj = await getChannel();
    if (chanelInfoObj) {
      storage.setItem('flag', chanelInfoObj.flagCode, null, 2);
      const token = storage.getItem('token', 1);
      const xdIsTag = storage.getItem('xdIsTag', 2);
      const xdSmsType = storage.getItem('xdSmsType', 2);
      if (token && xdIsTag == '1') {
        buriedPointNoTokenFn(true, [
          {
            currentPageCode: 'ysr100001',
            currentPageName: '访问页',
            fromPageCode: '',
            fromPageName: '',
            fromUrl: '',
            logTime: baseDayTimeMethod.getDateTime(),
            eventCode: 'JR_H5_USER_COMEIN',
            extraDataJson: {
              smsCode: xdSmsType,
            },
          },
        ]);
      }
      if (xdIsTag == '1') {
        buriedPointNoTokenFn(true, [
          {
            currentPageCode: 'ysr100001',
            currentPageName: '访问页',
            fromPageCode: '',
            fromPageName: '',
            fromUrl: '',
            logTime: baseDayTimeMethod.getDateTime(),
            eventCode: 'JR_H5_USER_COMEIN2',
            extraDataJson: {
              smsCode: xdSmsType,
            },
          },
        ]);
      }
      /**获取动态guide页面*/
      await getChannelDetailFn();
      const wechatOpenId = storage.getItem('wechatOpenId', 2);
      const wechatAppId = storage.getItem('wechatAppId', 2) as string;
      const msgId = storage.getItem('msgId', 2) as string;
      if (wechatOpenId && wechatAppId && msgId) {
        clickCount({
          day: baseDayTimeMethod.getDateDayNoLine(),
          msgId: storage.getItem('msgId', 2) || '',
          wechatAppId: wechatAppId,
          wechatOpenId: wechatOpenId,
        });
      }
      if (type === 'login') {
        h5Visit().then();
        /**访问埋点*/
        buriedCapital({ point: buriedPoint.TYPE_visit }).then();
        /**渠道埋点*/
        pointTrigger({ point: buriedPoint.TYPE_LANDING_VISIT }).then();
      }
    }
  };
  /**获取渠道数据*/
  const getChannel = () => {
    return getChannelFlagCode({
      channelId: storage.getItem('channelId', 2) || '',
      reqTime: baseDayTimeMethod.getDateTime(),
    }).then((res) => {
      return res;
    });
  };

  /* 协议 - 埋点 */
  const agreementPoint = async (key: string) => {
    const data = await getAgreementIds(key);
    const ids = data.map((item: any) => item.id).toString() || '';
    // console.log(ids, 'ids');
    const params = {
      agreementIds: ids,
      loanProductIds: '',
      signingScene: key,
    };
    contractSign(params).then();
  };

  /* 平台协议查询合规， 返回协议ID */
  const getAgreementIds = (key: string) => {
    return getAgreement({
      signingScene: key,
    }).then((res: any) => {
      if (res && res.data) {
        // console.log(res.data, '---------平台协议查询合规');
        return res.data || [];
      } else {
        return [];
      }
    });
  };
  const getAgreementXinDai = (key: string, platform?: string) => {
    const par: IObjStr = {
      signingScene: key,
    };
    if (platform) {
      par.platform = platform;
    }
    return getAgreementH5(par).then((res: any) => {
      if (res && res.data) {
        return res.data || [];
      } else {
        return [];
      }
    });
  };

  /**
   * 2023/04/28 新增埋点需求 已登录**/
  /**页面点击埋点
   * isBuriedPoint: 是否需要埋点
   * eventCode 点击事件的标识
   * extraDataJson 需要传递的后端参数
   * currentPageCode: 当前页code
   * currentPageName: 当前页名称
   * fromPageCode: 上一页code
   * fromPageName: 上一页name
   * fromUrl: 上一个URL
   * logTime: baseDayTimeMethod.getDateTime_()*/
  const buriedPointFn = (isBuriedPoint: boolean, listOld: Array<IObjStrObj>) => {
    console.log('埋点参数====', listOld);
    // isBuriedPoint && console.log('埋点参数====', listOld, listOld.length, isBuriedPoint);
    if (!isBuriedPoint) return;
    const list = JSON.parse(JSON.stringify(listOld));
    const promises = list.map((list_: IObjStrObj) => {
      if (list_.eventCode == 'JR_H5_USER_INFORMATION_MODE') {
        list_.extraDataJson = { infoType: 1 };
      }
      list_.appName = 'new-yousurong';
      list_.pageFlag = storage.getItem('flag', 2);
      list_.extraDataJson = JSON.stringify(list_.extraDataJson) || '';
      return operateBuried(list_);
    });
    return Promise.all(promises)
      .then(() => {
        return true;
      })
      .catch(() => {
        return true;
      });
  };
  /**
   * 2023/04/28 新增埋点需求 未登录**/
  /**页面点击埋点
   * isBuriedPoint: 是否需要埋点
   * eventCode 点击事件的标识
   * extraDataJson 需要传递的后端参数
   * currentPageCode: 当前页code
   * currentPageName: 当前页名称
   * fromPageCode: 上一页code
   * fromPageName: 上一页name
   * fromUrl: 上一个URL
   * logTime: baseDayTimeMethod.getDateTime_()*/
  const buriedPointNoTokenFn = (isBuriedPoint: boolean, listOld: Array<IObjStrObj>) => {
    // console.log('未登录埋点参数====', listOld, listOld.length);
    if (!isBuriedPoint) return;
    const list = JSON.parse(JSON.stringify(listOld));
    const promises = list.map((list_: IObjStrObj) => {
      list_.appName = 'new-yousurong';
      if (list_.extraDataJson) {
        list_.extraDataJson = JSON.stringify(list_.extraDataJson);
      }
      list_.pageFlag = storage.getItem('flag', 2);
      return operateBuriedNoToken(list_);
    });
    return Promise.all(promises)
      .then(() => {
        return true;
      })
      .catch(() => {
        return true;
      });
  };
  const pointTouch = (commonPointParam: IObjStr, keyName: string, keyContent: string) => {
    const token = storage.getItem('token', 1);
    if (token) {
      buriedPointFn(true, [
        {
          ...commonPointParam,
          eventCode: 'JR_H5_USER_KEY_CLICK',
          logTime: baseDayTimeMethod.getDateTime(),
          extraDataJson: {
            keyName: keyName,
            keyContent: keyContent,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...commonPointParam?.extraDataJson,
          },
        },
      ]);
    } else {
      buriedPointNoTokenFn(true, [
        {
          ...commonPointParam,
          eventCode: 'JR_H5_USER_KEY_CLICK',
          logTime: baseDayTimeMethod.getDateTime(),
          extraDataJson: {
            keyName: keyName,
            keyContent: keyContent,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...commonPointParam?.extraDataJson,
          },
        },
      ]);
    }
  };
  const initBaidu = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window._agl = window._agl || [];
    (function () {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-undef
      _agl.push(['production', '_f7L2XwGXjyszb4d1e2oxPybgD']);
      (function () {
        const agl = document.createElement('script');
        agl.type = 'text/javascript';
        agl.async = true;
        agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
        const s = document.getElementsByTagName('script')[0];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        s.parentNode.insertBefore(agl, s);
      })();
    })();
  };

  const initZhiFuBao = () => {
    if (navigator.userAgent.indexOf('AliApp') > -1) {
      const ksscript = document.createElement('script');
      ksscript.src = 'https://appx/web-view.min.js';
      const s = document.getElementsByTagName('script')[0];
      ksscript.setAttribute('type', 'text/javascript');
      s?.appendChild(ksscript);
    }
  };
  const initJL = () => {
    if (hasJavaScriptFile('https://analytics.oceanengine.com/api/v2/js/sdk')) {
      return;
    }
    (function (r, d, s) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      r._tt_config = true;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const _baq = (r._baq = r._baq || []);
      _baq.methods = ['track', 'off', 'on'];
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      _baq.factory = function (method) {
        return function () {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          // eslint-disable-next-line prefer-rest-params
          const args = Array.prototype.slice.call(arguments);
          args.unshift(method);
          _baq.push(args);
          return _baq;
        };
      };
      for (let i = 0; i < _baq.methods.length; i++) {
        const key = _baq.methods[i];
        _baq[key] = _baq.factory(key);
      }
      _baq.load = function () {
        const fjs = d.getElementsByTagName(s)[0];
        const js = d.createElement(s);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        js.src = 'https://analytics.oceanengine.com/api/v2/js/sdk';
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fjs.parentNode.insertBefore(js, fjs);
      };
      _baq.load();
      if (_baq.invoked) {
        return;
      }
      _baq.invoked = true;
      _baq.track('pageview');
    })(window, document, 'script');
  };
  const hasJavaScriptFile = (filename: string) => {
    const scripts = document.querySelectorAll('head script[src]');
    return Array.from(scripts).some((script: any) => script.src.endsWith(filename));
  };

  /** 上报clickId */
  const upClickIdFn = () => {
    const clickId_ = storage.getItem('clickId', 2);
    if (!clickId_) {
      return;
    }
    clickConversionUpClickId({
      clickId: clickId_,
      timeStamp: baseDayTimeMethod.getTimestampS().toString(),
    });
  };

  /** 写入粘贴板 */
  const guideToClipboard = async () => {
    const userId_ = storage.getItem('userId', 2) || '';
    const clickId_ = storage.getItem('clickId', 2) || '';
    const channelId_ = storage.getItem('channelId', 2);
    await toClipboard(`XDCHANNELDI-${channelId_}&-288888888&${userId_}&${clickId_}`);
  };
  const openInstallThis = ref<any>();
  const hasOpenInstallFile = (
    commonPointParam: IObjStr,
    isAuto = true,
    isAppBanner = true,
    fastInstall = false
  ) => {
    const openId = VITE_USER_NODE_ENV == 'production' ? 'clj5ew' : 'j0lxra';
    const src = 'https://web.cdn.openinstall.io/openinstall.js';
    const scripts = document.querySelectorAll('head script[src]');
    for (let i = 0; i < scripts.length; i++) {
      const script: any = scripts[i];

      if (
        script.src &&
        (script.src === src ||
          script.src.endsWith('/' + src) || // 处理相对路径
          script.src.includes(src)) // 处理复杂路径中的匹配
      ) {
        document.head.removeChild(script);
        break;
      }
    }
    initOpenInstall(commonPointParam, isAuto, isAppBanner, fastInstall);
  };
  const initOpenInstall = (
    commonPointParam: IObjStr,
    isAuto = true,
    showAppBanner = true,
    fastInstall = false
  ) => {
    const openId = VITE_USER_NODE_ENV == 'production' ? 'clj5ew' : 'j0lxra';
    if (showAppBanner) {
      const scriptAPP = document.createElement('script');
      const bannerId =
        VITE_USER_NODE_ENV == 'production' ? '2229934216190554458' : '874075513145779309';
      scriptAPP.src = 'https://web-' + openId + '.openinstall.com/web/banner.js?id=' + bannerId;
      document.head.appendChild(scriptAPP);
    }
    const scripta = document.createElement('script');
    scripta.src = 'https://web.cdn.openinstall.io/openinstall.js';
    scripta.onload = function () {
      const channelId_ = storage.getItem('channelId', 2);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // const data = OpenInstall.parseUrlParams();
      const data = { channelId: channelId_ };
      console.log(data, 'openinstall-data');
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      new OpenInstall(
        {
          //初始化方法，与openinstall服务器交互，应尽早调用
          appKey: openId, //appKey为openinstall为应用分配的唯一id（必须传入）
          channelCode: channelId_, //传入渠道编号，优先级大于链接上拼接的渠道编号
          fastInstall: fastInstall, //快速安装功能开关，true为开启，false为关闭
          onready: function () {
            openInstallThis.value = this;
            if (isAuto) {
              // iOS 自动 wakeupOrInstall 会走 OpenInstall 回落落地页整页跳走，进页自动下载只保留安卓
              if (isPhone() == 'IOS') {
                return;
              }
              buriedPointNoTokenFn(true, [
                {
                  ...commonPointParam,
                  logTime: baseDayTimeMethod.getDateTime(),
                  eventCode: 'JR_H5_API_TRACK_MODE',
                  extraDataJson: {
                    trackCode: 1,
                    trackName: '下载页默认触发下载次数(安卓)',
                  },
                },
                {
                  ...commonPointParam,
                  logTime: baseDayTimeMethod.getDateTime(),
                  eventCode: 'JR_H5_DOWNLOAD',
                  extraDataJson: {
                    downloadType: 0,
                    applyClick: 0,
                    automaticDownload: 1,
                    packageName: 'openInstall',
                  },
                },
              ]);
              console.log('openinstall初始化完成');
              upClickIdFn();
              this.schemeWakeup(); //尝试使用scheme打开App（主要用于Android以及iOS的QQ环境中）
              setTimeout(() => {
                guideToClipboard();
                this.wakeupOrInstall();
              }, 1500);
            }
          },
        },
        data
      );
    };
    document.head.appendChild(scripta);
  };
  const handOpenInstallDownload = (
    commonPointParam: IObjStr,
    name?: string,
    openinstall?: any,
    infoType?: number
  ) => {
    guideToClipboard();
    const pars: any = [
      {
        ...commonPointParam,
        logTime: baseDayTimeMethod.getDateTime(),
        eventCode: 'JR_H5_API_TRACK_MODE',
        extraDataJson: {
          trackCode: isPhone() == 'IOS' ? 2 : 1,
          trackName: `下载页默认触发下载次数(${isPhone() == 'IOS' ? 'ios' : '安卓'})`,
        },
      },
      {
        ...commonPointParam,
        logTime: baseDayTimeMethod.getDateTime(),
        eventCode: 'JR_H5_DOWNLOAD',
        extraDataJson: {
          downloadType: 2,
          applyClick: 1,
          automaticDownload: 0,
          packageName: '',
        },
      },
    ];
    if (name) {
      const extraDataJson = infoType ? { keyName: name, keyContent: name, infoType } : { keyName: name, keyContent: name };
      pars.push({
        ...commonPointParam,
        logTime: baseDayTimeMethod.getDateTime(),
        eventCode: 'JR_H5_USER_KEY_CLICK',
        extraDataJson,
      });
    }
    buriedPointNoTokenFn(true, pars);
    if (openinstall) {
      openinstall.schemeWakeup();
      setTimeout(() => {
        openinstall.wakeupOrInstall();
        guideToClipboard();
      }, 500);
    } else {
      console.log(openInstallThis.value, '=====xxxx====')
      openInstallThis.value.schemeWakeup();
      setTimeout(() => {
        openInstallThis.value.wakeupOrInstall();
        guideToClipboard();
      }, 500);
    }
  };
  let pressTimer: any;
  /**长按识别二维码*/
  const longerProcessTouchStart = (e: any, erData: any) => {
    e.preventDefault();
    pressTimer = setTimeout(() => {
      window.location.href = erData.url;
    }, 800); // 800ms 视为长按
  };
  const longerProcessTouchEnd = () => {
    console.log('长按识别二维码离开');
    clearTimeout(pressTimer);
    pressTimer = null;
  };

  return {
    initPage,
    agreementPoint,
    getAgreementIds,
    getAgreementXinDai,
    buriedPointFn,
    buriedPointNoTokenFn,
    pointTouch,
    initZhiFuBao,
    initBaidu,
    upClickIdFn,
    guideToClipboard,
    initJL,
    getChannel,
    initOpenInstall,
    hasJavaScriptFile,
    openInstallThis,
    handOpenInstallDownload,
    longerProcessTouchStart,
    longerProcessTouchEnd,
    hasOpenInstallFile,
  };
}
